// extracted by mini-css-extract-plugin
module.exports = {"menu":"_3t3-q","item":"_2F9Qr","danger":"_35v5z"};